const DROPPED_WORDS = new Set(['pty', 'ltd', 'the', 'of', 'and', 'limited', 'trust', 'fund']);

const STARTS_WITH_LETTER_OR_DIGIT = /^[\p{L}\p{N}]/u;

/**
 * The letters shown in an entity's avatar: the first letters of its first two meaningful words.
 *
 * Words split on spaces and "&". A word that starts with punctuation, such as "(NSW)", and the
 * company-form words in DROPPED_WORDS are skipped. When every word is skipped, the first
 * character of the name stands in, so a name that has any character still gets an avatar. This is
 * the ruled board's rule, quirks included: a leading punctuation character or space can be the
 * fallback, and a word such as "Pty." with a full stop is not dropped.
 */
export function toEntityInitials(name: string): string {
  const words = name.replace(/&/g, ' ').split(/\s+/).filter(Boolean);
  const meaningfulWords = words.filter(
    (word) => STARTS_WITH_LETTER_OR_DIGIT.test(word) && !DROPPED_WORDS.has(word.toLowerCase()),
  );
  const initials = meaningfulWords
    .slice(0, 2)
    .map((word) => [...word][0])
    .join('');

  const firstCharacter = [...name][0] ?? '';
  return (initials || firstCharacter).toUpperCase();
}
